import './timeregistration-summary.css';
import { convertValueToHoursAndMinutes } from '../../../utils/convertValueToHoursAndMinutes';

const mapSummaryKeyToLabel = {
  work: 'Arbejdstid',
  sickLeave: 'Sygdom',
  timeOff: 'Fri',
  holidays: 'Ferie',
  overtime: 'Arbejde uden for normtid',
};

const calculateSummary = (allUsersMetrics) => {
  const summaryMetrics = {
    normTime: 0,
    work: 0,
    overtime: 0,
    sickLeave: 0,
    timeOff: 0,
    holidays: 0,
  };

  Object.values(allUsersMetrics).forEach((userMetrics) => {
    summaryMetrics.normTime += userMetrics.normTime;
    summaryMetrics.work += userMetrics.work.hours;
    summaryMetrics.overtime += userMetrics.overtime.hours;
    summaryMetrics.sickLeave += userMetrics.sickLeave.hours;
    summaryMetrics.timeOff += userMetrics.timeOff.hours;
    summaryMetrics.holidays += userMetrics.holidays.hours;
  });

  return summaryMetrics;
};

function SummaryItem({ label, value, percentage, normTime }) {
  return (
    <div className="timeregistration-summary-item">
      <div className="timeregistration-summary-item-top">
        <h5 className="timeregistration-summary-item-label">{label}</h5>
        {percentage !== 0 && (
          <span className="timeregistration-summary-item-percentage">
            {percentage}%
          </span>
        )}
      </div>
      <h2 className="timeregistration-summary-item-value">{value}</h2>
      {normTime > 0 && (
        <span className="timeregistration-summary-item-normtime">
          Normtid: {normTime} timer
        </span>
      )}
    </div>
  );
}

function TimeRegistrationSummary({ metrics }) {
  const calculatedSummary = calculateSummary(metrics);
  const calculatePercentage = (value, key) => {
    if (key === 'overtime') {
      return 0;
    }

    // Exclude normTime and actualWorkHours from the total calculation
    const total = Object.keys(calculatedSummary).reduce((acc, k) => {
      if (k !== 'normTime' && k !== 'actualWorkHours' && k !== 'overtime') {
        return acc + calculatedSummary[k];
      }
      return acc;
    }, 0);

    return total > 0
      ? ((value / total) * 100).toLocaleString('da-DK', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })
      : (0).toLocaleString('da-DK', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        });
  };

  return (
    <div className="timeregistration-summary">
      {Object.entries(mapSummaryKeyToLabel).map(([key, label]) => (
        <SummaryItem
          key={key}
          label={label}
          value={convertValueToHoursAndMinutes(calculatedSummary[key])}
          percentage={calculatePercentage(calculatedSummary[key], key)}
          normTime={key === 'work' ? calculateSummary(metrics).normTime : 0}
        />
      ))}
    </div>
  );
}

export default TimeRegistrationSummary;
